import React, { FC, useEffect, useCallback, useState } from 'react'
import get from 'lodash/get'
import { useFloor } from '@providers/mapProvider'
import UploadSpaceImages from '../UploadSpaceImages/UploadSpaceImages'
import api, { ISpaceDetails } from '../../api'
import { Toaster } from '../UI'

type SelectedSpaceTabPropsT = {
  updateDefaultImage: boolean
  setUpdateDefaultImage: (value: boolean) => void
}

const SelectedSpaceTab: FC<SelectedSpaceTabPropsT> = ({
  updateDefaultImage,
  setUpdateDefaultImage,
}) => {
  const floor = useFloor()
  const [isSpaseDetailsLoading, setIsSpaseDetailsLoading] = useState(false)
  const [spaceDetails, setSpaceDetails] = useState<ISpaceDetails | null>(null)
  const selectedSpaceId = get(floor, 'selection.selectedSpacesList[0]', '')

  const spaceDetailsHandler = useCallback(async () => {
    try {
      setIsSpaseDetailsLoading(true)
      const spaceDetails = await api.space.details(selectedSpaceId)
      setSpaceDetails(spaceDetails)
    } catch (error: any) {
      Toaster.fail({ error })
    } finally {
      setIsSpaseDetailsLoading(false)
    }
  }, [selectedSpaceId])

  useEffect(() => {
    spaceDetailsHandler()
  }, [spaceDetailsHandler])

  if (!spaceDetails) return null

  return (
    <UploadSpaceImages
      spaceId={selectedSpaceId}
      isAssetsLoading={isSpaseDetailsLoading}
      assets={spaceDetails.assets}
      updateDefaultImage={updateDefaultImage}
      setUpdateDefaultImage={setUpdateDefaultImage}
    />
  )
}

export default SelectedSpaceTab
